/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/exports-last */
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'

type StyledWidgetContainerProps = {
  isExpanded: boolean
  isFastlaneEnabled: boolean
}

const sharedContainerStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`
export const StyledWidgetContainer = styled(sharedContainerStyles)<StyledWidgetContainerProps>`
  box-sizing: border-box;
  align-items: flex-start;
  padding: 16px;
  gap: 20px;
  border-radius: 4px;
  border: 1px solid #d4d4d6;
  background: #fff;
  height: ${({ isExpanded, isFastlaneEnabled }) => (isExpanded || isFastlaneEnabled ? 'auto' : '62px')};
`

export const StyledHeaderContainer = styled(sharedContainerStyles)`
  align-items: flex-start;
  gap: 8px;
`

export const StyledTextAndIconContainer = styled(sharedContainerStyles)<StyledWidgetContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${({ isFastlaneEnabled }) => (isFastlaneEnabled ? '8px' : '16px')};
  cursor: pointer;
`

export const StyledInputContainer = styled(sharedContainerStyles)`
  align-items: flex-start;
  gap: 12px;
  margin-top: -6px;
`

export const StyledButtonContainer = styled(sharedContainerStyles)<{ isDesktop: boolean }>`
  align-items: center;
  gap: 16px;
  margin-top: ${({ isDesktop }) => (isDesktop ? '-20px' : '-5px')};
`

export const StyledButton = styled.button`
  display: flex;
  height: 48px;
  padding: 0px 24px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #282832;
  background: #282832;
  cursor: pointer;

  &:disabled {
    opacity: 1;
    cursor: not-allowed;
    border: 2px solid #acacac;
    background-color: #acacac;
  }
`

const sharedTextStyles = styled.span`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
`

export const StyledLargeBoldText = styled(sharedTextStyles)`
  font-size: 20px;
  font-weight: 500;
  line-height: 150%;
`

export const StyledGrayText = styled(sharedTextStyles)`
  color: #3e3e47;
  font-size: 14px;
  font-weight: 400;
  line-height: 165%;
`

export const StyledButtonText = styled(sharedTextStyles)`
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 165%;
`

export const StyledForgotPasswordText = styled(sharedTextStyles)`
  color: #05629b;
  font-size: 12px;
  font-weight: 400;
  line-height: 165%;
  text-decoration-line: underline;
  cursor: pointer;
`

export const StyledErrorText = styled(sharedTextStyles)`
  color: ${({ color }) => color || '#c33'};
  font-size: 12px;
  font-weight: 400;
  line-height: 165%;
  padding-left: 4px;
`

export const StyledLabelText = styled.span`
  color: #282832;
  font-size: 20px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-weight: 500;
  line-height: 30px;
  word-wrap: break-word;
`

export const StyledLabelHeader = styled.span`
  color: #3E3E47;
  font-size: 14px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
`

export const StyledFrame = styled.div`
  flex: 1 1 0;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  display: inline-flex;
`